import {t} from "@lingui/macro";

export const handleDeferErrorMessages = (details: { [id: string]: string }|null): {message: string, severity: "error" | "info" | "success" | "warning"} => {
    if (details?.["error"] === "ACTION_DEADLINE_IS_NOT_BEFORE") {
        return {
            message: t({
                id: "action.defer.error-before",
                message: "La data selezionata deve essere precedente a quella dell'azione successiva."
            }),
            severity: "error"
        }

    }
    if (details?.["error"] === "ACTION_DEADLINE_IS_NOT_AFTER") {
        return {
            message: t({
                id: "action.defer.error-after",
                message: "La data selezionata deve essere successiva a quella dell'azione precedente."
            }),
            severity: "error"
        }
    }
    if (details?.["error"] === "ACTION_DEADLINE_IS_NOT_BETWEEN") {
        return {
            message: t({
                id: "action.defer.error-between",
                message: "La data selezionata deve essere compresa tra la data di scadenza dell'azione precedente e quella dell'azione successiva."
            }),
            severity: "error"
        }
    }

   return {
        message:  t({id: "action.defer.generic-error", message: "Qualcosa è andato storto con l'inserimento della data."}),
        severity: "error"
   }
}
